import apiAxios from "helpers/apiAxios";
import React, { useState } from "react"
import { Modal, Button, FormInput, FormSelect } from "components/common"
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const NewSiteModal = ({ showModal, setshowModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    country: 'VN',
    currency: 'VND'
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      await apiAxios.post("/organization/sites", formData)
      toast.success(`Site ${formData.name} has been created sucessfully.`)
      setshowModal(false)
    }
    catch (error) {
      toast.error(error.message)
    }
  }

  const handleCancel = () => {
    setshowModal(false)
  }

  const handleChange = ({ target }) => {
    let name = target.name;
    setFormData({ ...formData, [name]: target.value })
  }

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      title="New Site"
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" form="new-site-form">Save</Button>
          <Button size="sm" variant="danger" onClick={handleCancel}>Cancel</Button>
        </>
      )}
    >
      <form id="new-site-form" onSubmit={handleSubmit}>
        <h6 className="tw-text-blue-600 tw-font-semibold tw-text-sm tw-mb-3">Create a new Site</h6>
        <div className="tw-flex tw-flex-col tw-gap-3">
          <FormInput
            label="Site name"
            placeholder="Site name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          <FormInput
            label="Country"
            placeholder="Country"
            name="country"
            value={formData.country}
            onChange={handleChange}
          />
          <FormSelect
            label="Currency"
            name="currency"
            value={formData.currency}
            onChange={handleChange}
            options={[
              { value: 'VND', label: 'VND' },
              { value: 'USD', label: 'USD' },
            ]}
          />
        </div>
      </form>
    </Modal>
  )
};

NewSiteModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired
}

export default NewSiteModal;
